import React from 'react';
import { Globe, CreditCard, Calendar } from 'lucide-react';

/**
 * Компонент секции выбора визы
 */
const VisaSelectionSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  countries,
  countryCategories,
  visaTypes,
  processingTimes
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-4">
        Основные параметры визы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Страна */}
        <div>
          <label htmlFor="country" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Globe className="w-4 h-4 mr-2 text-purple-500" />
            Страна получения визы
          </label>
          <select
            id="country"
            name="country"
            value={formData.country}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.country ? 'input-error' : ''}`}
          >
            {countryCategories.map(category => (
              <optgroup key={category.id} label={category.name}>
                {countries
                  .filter(country => country.category === category.id)
                  .map(country => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))
                }
              </optgroup>
            ))}
          </select>
          {errors.country && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.country}
            </p>
          )}
        </div>

        {/* Тип визы */}
        <div>
          <label htmlFor="visaType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <CreditCard className="w-4 h-4 mr-2 text-purple-500" />
            Тип визы
          </label>
          <select
            id="visaType"
            name="visaType"
            value={formData.visaType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.visaType ? 'input-error' : ''}`}
          >
            {visaTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.visaType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.visaType}
            </p>
          )}
        </div>

        {/* Категория визы */}
        <div>
          <label htmlFor="visaCategory" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Категория визы
          </label>
          <select
            id="visaCategory"
            name="visaCategory"
            value={formData.visaCategory}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="standard">Стандартная</option>
            <option value="premium">Премиум</option>
            <option value="economic">Эконом</option>
          </select>
        </div>

        {/* Количество въездов */}
        <div>
          <label htmlFor="entryType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество въездов
          </label>
          <select
            id="entryType"
            name="entryType"
            value={formData.entryType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="single">Однократная</option>
            <option value="double">Двукратная</option>
            <option value="multiple">Многократная</option>
          </select>
        </div>

        {/* Срок действия визы */}
        <div>
          <label htmlFor="visaDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-purple-500" />
            Срок действия визы (дней)
          </label>
          <input
            type="text"
            id="visaDuration"
            name="visaDuration"
            value={formData.visaDuration}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.visaDuration ? 'input-error' : ''}`}
            placeholder="Введите срок в днях"
          />
          {errors.visaDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.visaDuration}
            </p>
          )}
        </div>

        {/* Срок обработки */}
        <div>
          <label htmlFor="processingTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Срок обработки
          </label>
          <select
            id="processingTime"
            name="processingTime"
            value={formData.processingTime}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {processingTimes.map(time => (
              <option key={time.id} value={time.id}>
                {time.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default VisaSelectionSection;